<app-global-loading *ngIf="loading"></app-global-loading>
<section id="view-order-list" class="view-order-list">
  <div class="tabs">
    <div class="mtab" [class.active]="status === ''" (click)="changeStatus('')">
      全部
    </div>
    <div
      class="mtab"
      [class.active]="status === 'Paid'"
      (click)="changeStatus('Paid')"
    >
      已支付
    </div>
    <!-- <div
      class="mtab"
      [class.active]="status === 'Unpaid'"
      (click)="changeStatus('Unpaid')"
    >
      待付款
    </div> -->
    <div
      class="mtab"
      [class.active]="status === 'Pending'"
      (click)="changeStatus('Pending')"
    >
      待解决
    </div>
    <div
      class="mtab"
      [class.active]="status === 'Completed'"
      (click)="changeStatus('Completed')"
    >
      已完成
    </div>
  </div>

  <div class="orders-grid" id="orders-container">
    <ng-container *ngIf="orders?.length; else noData">
      <ng-container *ngFor="let o of orders">
        <app-order-card [o]="o"></app-order-card>
      </ng-container>
    </ng-container>
    <ng-template #noData>
      <div class="oc-empty">
        <div class="oc-empty-icon">
          <mat-icon>assignment</mat-icon>
        </div>

        <div class="oc-empty-title">暂无订单</div>
      </div>
    </ng-template>
  </div>
</section>
